// extracted by mini-css-extract-plugin
export default {"message":"messages_message__UmdUq"};